// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instance-permission-grid .ant-table-cell.operation-column {
  font-size: 1.5em;
  text-align: center;
}
.instance-permission-grid .ant-table-cell.operation-column .anticon {
  cursor: pointer;
}
.instance-permission-grid .ant-table-cell.operation-column .anticon.anticon-delete {
  color: #ea2f5a;
}
.ant-table-filter-dropdown .column-search {
  padding: 8px;
}
.ant-table-filter-dropdown .column-search input {
  margin-bottom: 8px;
  display: block;
}
.ant-table-filter-dropdown .column-search button {
  width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/FormField/Permission/InstancePermissionGrid/InstancePermissionGrid.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;EACA,kBAAA;AAAJ;AAHA;EAMM,eAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAMA;EAEI,YAAA;AALJ;AAGA;EAKM,kBAAA;EACA,cAAA;AALN;AADA;EAUM,YAAA;AANN","sourcesContent":[".instance-permission-grid {\n  .ant-table-cell.operation-column {\n    font-size: 1.5em;\n    text-align: center;\n\n    .anticon {\n      cursor: pointer;\n\n      &.anticon-delete {\n        color: #ea2f5a;\n      }\n    }\n  }\n}\n\n.ant-table-filter-dropdown {\n  .column-search {\n    padding: 8px;\n\n    input {\n      margin-bottom: 8px;\n      display: block;\n    }\n\n    button {\n      width: 120px;\n    }\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
